// removed by extract-text-webpack-plugin
module.exports = {"spinner":"src-components-Spinner__spinner--3C2E-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner.scss
// module id = 86
// module chunks = 0